import axios from 'axios'
import {md5} from '~/assets/movie/js/md5'

export async function request (config) {
  let rsp = await axios(config)
  return rsp.data

}
